import { Outlet, useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import Navbar from "@/widgets/layout/Navbar"
import Footer from "@/widgets/layout/Footer"

export default function MainLayout() {
  const { t } = useTranslation()
  const { search } = useLocation()
  const isEmbedMode = new URLSearchParams(search).get("embed") === "1"

  return (
    <div className="min-h-screen font-sans flex flex-col bg-white">
      {isEmbedMode ? null : (
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 z-[60] px-4 py-2 rounded-md bg-white text-brand-500 text-sm font-semibold shadow-md border border-brand-500"
        >
          {t("common.skipToContent")}
        </a>
      )}
      {isEmbedMode ? null : <Navbar />}
      <main id="main-content" tabIndex={-1} className="flex-1 w-full focus:outline-none">
        <Outlet />
      </main>
      {isEmbedMode ? null : <Footer />}
    </div>
  )
}
